import Icon from '@components/style/Icon.style'
import Card from 'parkdepot-shared/components/Card'
import React, { FC, ReactNode } from 'react'
import { CardOverrides, Description, NegativeIconStyle, PositiveIconStyle, Title } from './FinalCard.style'
import FormPlateInput from 'parkdepot-shared/components/LPInput'

type FinalCardProps = {
    plate: string
    country?: string
    title?: string
    description?: ReactNode
    result?: 'success' | 'error'
}

export const FinalCard: FC<FinalCardProps> = ({ plate, country, title, description, result }) => {
    return (
        <Card styleOverrides={CardOverrides}>
            <Icon
                $style={result === 'success' ? PositiveIconStyle : NegativeIconStyle}
                className={result === 'success' ? 'wemolo-check-circle' : 'wemolo-cross-circle'}
            />
            <Title $error={result === 'error'}>{title}</Title>
            <Description>{description}</Description>
            <FormPlateInput disabled readOnly value={plate} country={country} />
        </Card>
    )
}
